import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ProgressText from '../../components/progress-text/Progress';
import Button from '../../components/button/Button';
import { stepStore } from '../../mobx/stores/step';
import Popup from '../../components/modal/Popup';
import Panel from '../../components/panel';
import switchPopup from '../../components/switch-popup/index';
import Toast from '../../components/toast/Toast';
import nativeInterface from '../../native-interact/native';
// import RfLog from './modules/RfLog';
import BaseInfo from './modules/BaseInfo';
import closeImg from '../../assets/imgs/input-delete.png';


function PanelGroup(props) {
  return (
    <div>
      <p style={{ lineHeight: '30px' }}>{props.panelTitle}</p>
      <div className="panel-group">
        {props.panels}
      </div>
      <div className="popup-group">
        {props.panelPopups}
      </div>
    </div>
  );
}

function getPanel(panelTitle, panels, showFn, globalStore, onbt) {
  const panelComps = [];
  panels.forEach((item, index) => {
    if ((typeof item.show === 'function' && item.show()) || item.show === true) {
      panelComps.push(
        <Panel
          key={item.title}
          title={item.title}
          defaultText={item.defaultText}
          status={item.status}
          onClick={() => {
            if (!globalStore.btOnConnect && onbt) {
              Toast.fail('蓝牙未连接');
              return;
            }
            showFn(index);
          }}
        />
      );
    }
  });
  const popups = panels.map((item, index) => {
    const { title, PanelComponent, visible, bodyStyle, ...rest } = item;
    return (
      <Popup
        key={title}
        visible={visible}
        bodyStyle={bodyStyle}
        onClose={() => {
          // if (title !== '恢复出厂设置') {
          //   panels[index].visible = false;
          // }
        }}
      >
        <img src={closeImg} alt="" style={{ float: 'right' }} onClick={() => { panels[index].visible = false; }} />
        {
          // 可能引起的bug，panel多次点击后触发panelcomponent didmount,如果存在异步回调引用this属性，则前几次调用由于组件已经销毁所以属性不存在
          visible ? (
            <PanelComponent
              closePanel={() => {
                // eslint-disable-next-line no-param-reassign
                panels[index].visible = false;
              }}
              {...rest}
            />
          ) : (
            ''
          )
        }
      </Popup>
    );
  });

  return (
    <PanelGroup
      panelTitle={panelTitle}
      panels={panelComps}
      panelPopups={popups}
    />
  );
}

class DebugNormal extends Component {
  state = {
    showLog: false
  }

  onPanelClose(index) {
    this.props.store.panels[index].visible = false;
  }

  closeLog = () => {
    this.setState({
      showLog: false
    });
  }

  switchMode() {
    switchPopup.showSwitchPopup('normal');
  }

  next() {
    stepStore.next();
  }

  render() {
    const store = this.props.store;
    const { blePanels, rfPanels, rfWritePanels } = store;
    const { showSwitch = true, showNext = true } = this.props;

    return (
      <div>
        {/* <RfLog show={this.state.showLog} onCloseLog={this.closeLog} /> */}
        <BaseInfo show={this.state.showLog} onCloseLog={this.closeLog} />
        {
          showSwitch ? (
            <ProgressText text="请点击按钮进行调试" hasPre>
              <Button type="ghost" className="switch-btn" onClick={() => this.switchMode()}>切换模式</Button>
            </ProgressText>
          ) : ''
        }
        {getPanel('蓝牙相关命令:', blePanels, store.showBlePanel.bind(store), this.props.globalStore, true)}
        {getPanel('读卡器蓝牙命令:', rfPanels, store.showRfPanel.bind(store), this.props.globalStore, true)}
        {getPanel('读卡器写卡命令:', rfWritePanels, store.showRfWritePanel.bind(store), this.props.globalStore)}
        <PanelGroup
          panelTitle="其他功能:"
          panels={[
            <Panel
              title="图表"
              defaultText="图表"
              status="default"
              key="1"
              onClick={() => {
                nativeInterface.showChart();
              }}
            />,
            // <Panel
            //   title="工作模式"
            //   defaultText="工作模式"
            //   status="default"
            //   key="2"
            //   onClick={() => {
            //     this.setState({
            //       showLog: true
            //     });
            //   }}
            // />
            <Panel
              title="基本信息"
              defaultText="基本信息"
              status="default"
              key="2"
              onClick={() => {
                this.setState({
                  showLog: true
                });
              }}
            />
          ]
          }
        />
        {
          showNext ? (
            <div className="next">
              <Button type="primary" onClick={this.next}>下一步</Button>
            </div>
          ) : ''
        }
      </div>
    );
  }
}

export default observer(DebugNormal);
